import { useContext, useState } from 'react'

import { ToastContext, useFetch } from '@reveni-io/reveni-ui'

import { resendCooldownSeconds } from '@/FindOrdersPage/constants'
import services from '@/services/services'

import useResendCooldown from '../useResendCooldown/useResendCooldown'
import { transformRequestOrderRecoveryLink } from './transformers'

const useOrderRecoveryLink = ({ portalId }) => {
  const { setToastInfo } = useContext(ToastContext)
  const [email, setEmail] = useState('')
  const [isEmailValid, setIsEmailValid] = useState(false)
  const [showCheckYourEmailModal, setShowCheckYourEmailModal] = useState(false)
  const { loading, fetchData: requestRecoveryLink } = useFetch(services.requestOrderRecoveryLink, {
    doInitialRequest: false,
    transformRequest: transformRequestOrderRecoveryLink,
  })
  const { secondsLeft, restart: restartCooldown } = useResendCooldown(resendCooldownSeconds)

  const sendRecoveryLink = async () => {
    try {
      await requestRecoveryLink({ portalId, email })
      setShowCheckYourEmailModal(true)
      restartCooldown()
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  const handleEmailChange = (e, isValid) => {
    setEmail(e.target.value)
    setIsEmailValid(isValid)
  }

  const closeCheckYourEmailModal = () => setShowCheckYourEmailModal(false)

  return {
    email,
    isEmailValid,
    handleEmailChange,
    sendRecoveryLink,
    loading,
    showCheckYourEmailModal,
    closeCheckYourEmailModal,
    secondsToResend: secondsLeft,
  }
}

export default useOrderRecoveryLink
